/**
 * bp-blog-slider.js
 * Blog Section Slider — Flickity-powered
 * Desktop: 3-up, prev/next arrows top-right
 * Mobile:  1-up, dot pagination
 *
 * Safe to include alongside existing SlideShow class.
 * Uses unique prefix "bp" to avoid conflicts.
 */

(function () {
  'use strict';

  function initBpBlogSliders() {
    var tracks = document.querySelectorAll('.bp-slider__track');
    if (!tracks.length) return;

    tracks.forEach(function (track) {
      // Don't double-init
      if (track.dataset.bpInitiated) return;

      var section = track.closest('.bp-slider-section');
      if (!section) return;

      var prevBtn  = section.querySelector('.bp-slider__arrow--prev');
      var nextBtn  = section.querySelector('.bp-slider__arrow--next');
      var isMobile = window.innerWidth < 768;

      var flkty = new Flickity(track, {
        cellSelector:    '.bp-slider__slide',
        cellAlign:       'left',
        contain:         true,
        wrapAround:      true,
        prevNextButtons: false,
        pageDots:        isMobile,   // dots on mobile only
        groupCells:      isMobile ? 1 : 3,  // advance 3 at a time on desktop
        draggable:       true,
        freeScroll:      false,
        adaptiveHeight:  false,
        imagesLoaded:    true,
      });

      // Arrow clicks (desktop)
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          flkty.previous(true);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          flkty.next(true);
        });
      }

      track.dataset.bpInitiated = 'true';

      // Re-init on significant resize (mobile ↔ desktop breakpoint)
      var resizeTimer;
      var cachedMobile = isMobile;

      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var nowMobile = window.innerWidth < 768;
          if (nowMobile !== cachedMobile) {
            cachedMobile = nowMobile;
            flkty.destroy();
            track.removeAttribute('data-bp-initiated');
            initBpBlogSliders();
          }
        }, 300);
      });
    });
  }

  // Init after DOM + Flickity are ready
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    // Small delay to let Flickity (and theme JS) finish loading
    if (typeof Flickity !== 'undefined') {
      initBpBlogSliders();
    } else {
      // Wait for Flickity if loaded asynchronously
      var checkInterval = setInterval(function () {
        if (typeof Flickity !== 'undefined') {
          clearInterval(checkInterval);
          initBpBlogSliders();
        }
      }, 100);
    }
  });

})();